import axios from "axios";
import { IHeritageToken } from "../types/IHeritageConnection";

export const getHeritageConnection = async (): Promise<IHeritageToken> => {
  const response = await axios.get<IHeritageToken>(
    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/heritage-connection`,
  );
  return response.data;
};
